var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4238 20.0019C36.4238 22.0169 34.764 23.6767 32.749 23.6767H23.753L19.1595 33.9736L18.8533 34.7012H12.9968L14.2218 23.6767H11.963L9.85853 26.8162L9.5131 27.3515H4.3071L4.61333 25.8963L5.8003 20.0019L4.61333 14.1062L4.3071 12.6522L9.5131 12.6522L9.85853 13.1888L11.9618 16.3271H14.2205L12.9956 5.30259H18.8521L19.1583 6.0302L23.753 16.3271H32.749C34.764 16.3271 36.4238 17.9869 36.4238 20.0019ZM33.9739 20.0019C33.9739 19.3086 33.4423 18.7769 32.749 18.7769H22.1459L21.8397 18.0493L17.2462 7.75247H15.7529L16.9779 18.7769H10.6229L10.2799 18.2404L8.17179 15.1021L7.29228 15.1021L8.21099 19.7728L8.28693 20.0019L8.21099 20.2322L7.29228 24.9016H8.17179L10.2787 21.7621L10.6217 21.2268H16.9767L15.7517 32.2513H17.2449L21.8385 21.9544L22.1447 21.2268H32.749C33.4423 21.2268 33.9739 20.6952 33.9739 20.0019Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.46e49a52150522df2e43ad3dcc52f48e.svg";
export { ForwardRef as ReactComponent };